

function PDFPage8Table2(props: any) {
    let people_owned = parseFloat(props?.data?.personowned?.percentageofallshares) + parseFloat(props?.otherSpace?.personowned?.percentageofallshares);
    let Company_owned = parseFloat(props?.data?.companyowned?.percentageofallshares) + parseFloat(props?.otherSpace?.companyowned?.percentageofallshares);
    return (
        <>
            <table className="table table-sm table-bordered cu-table-border table-striped cu-fs-12">
                <thead className="cu-bg-green  ">
                    <tr>
                        <th className="fw-600">
                            {props.TranslateString("Autopaikkoja 4 kpl / X number of car spaces (dynamic table & text)**")?.replace("X",props?.shareholderData?.getAllData?.noofcarspaces) + ", " +
                            props.TranslateString("muut_tilat_y_kpl")?.replace("Y",props?.shareholderData?.getAllData?.noofotherspaces) }
                        </th>
                        <th className="cu-width-20p text-right fw-600">{props.TranslateString("Paikat lkm")}</th>
                        <th className="cu-width-20p text-right fw-600">{props.TranslateString("number_of_other_spaces")}</th>
                        <th className="cu-width-30p text-right fw-600">{props.TranslateString("the_percentage_of_the_shares_owned_of_hc")}</th>
                    </tr>
                </thead>
                <tbody className="bg-light">
                    <tr>
                        <td>{props.TranslateString("Yksityisomistuksessa / People-owned")} </td>
                        <td className="text-right">{props?.data?.personowned?.numberofspaces || 0} </td>
                        <td className="text-right">{props?.otherSpace?.personowned?.numberofspaces || 0} </td>
                        <td className="text-right">{props?.data?.personowned?.total_percentages + ' %'|| "0 %"} </td>
                        {/* <td className="text-right">{ people_owned ? people_owned?.toFixed(1)?.replace('.',',') + ' %' : "0 %"}</td> */}
                    </tr>
                    <tr>
                        <td>{props.TranslateString("Yritysten omistuksessa / Company-owned")}</td>
                        <td className="text-right">{props?.data?.companyowned?.numberofspaces || 0}</td>
                        <td className="text-right">{props?.otherSpace?.companyowned?.numberofspaces || 0}</td>
                        <td className="text-right">{props?.data?.companyowned?.total_percentages + ' %' || "0 %"}</td>
                        {/* <td className="text-right">{Company_owned ? Company_owned?.toFixed(1)?.replace('.',',') + ' %' : "0 %"}</td> */}
                    </tr>
                </tbody>
            </table>
        </>
    );
}

export default PDFPage8Table2;